module.exports = __webpack_public_path__ + "img/zigzag-arrow.9b78fff5.svg";